import { render, staticRenderFns } from "./SocleNotificationList.vue?vue&type=template&id=6e5d789e&"
import script from "./SocleNotificationList.vue?vue&type=script&lang=ts&"
export * from "./SocleNotificationList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports